import { Alert, Badge, Card, Field, Select, TextArea } from "./ui.jsx";
import { useOccurrence } from "../context/OccurrenceContext";
import { itemIneligibilityReason } from "../utils/eligibility.js";
import { availableActions, defaultIncludeAction, isChosenAction } from "../utils/orderItems.js";
import { handlePrice, optionsReasons } from "../utils/utils";
import styles from "../pages/Products.module.css";

const ProductItem = ({
  skuId,
  line,
  selectedAction,
  handleSelectedAction,
  selectedReason,
  handleSelectedReason,
  getActionName,
  selectedExplication,
  handleSelectedExplication,
}) => {
  const { order } = useOccurrence();
  const actions = availableActions(order, line);
  const ineligibleReason = itemIneligibilityReason(line);
  const included = selectedAction[skuId] && selectedAction[skuId] !== "Manter";
  const eligible = !ineligibleReason && actions.length > 0;
  const canChooseWarranty = actions.some((item) => item.value === "Garantia");
  const selectedType = isChosenAction(selectedAction[skuId])
    ? selectedAction[skuId]
    : defaultIncludeAction(order, line);

  return (
    <Card className={styles.itemCard}>
      <div className={styles.itemHead}>
        <div className={styles.img}>
          {line?.image ? (
            <img src={line.image} alt="" />
          ) : (
            <div className={styles.imgFallback} aria-hidden="true" />
          )}
        </div>
        <div className={styles.productInfo}>
          <p className={styles.productTitle}>{line?.title || "Produto"}</p>
          {line?.variant_title ? <p className={styles.productMeta}>{line.variant_title}</p> : null}
          <p className={styles.productPrice}>R$ {handlePrice(line?.price)}</p>
          {line?.hasWarranty ? <Badge tone="success">Em garantia</Badge> : null}
        </div>
      </div>

      <label className={styles.include}>
        <input
          type="checkbox"
          checked={Boolean(included)}
          disabled={!eligible}
          onChange={(event) => handleSelectedAction(skuId, event.target.checked ? defaultIncludeAction(order, line) : "Manter")}
        />
        {eligible ? "Incluir este item" : "Item indisponível para esta solicitação"}
      </label>
      {ineligibleReason ? <Alert tone="info">{ineligibleReason}</Alert> : null}
      {!ineligibleReason && !eligible ? (
        <p className={styles.helper}>Fora do prazo ou sem garantia.</p>
      ) : null}

      {included ? (
        <div className={styles.additional}>
          {canChooseWarranty ? (
            <Field id={`${skuId}-action`} label="Tipo da solicitação">
              <Select
                id={`${skuId}-action`}
                value={selectedType}
                required
                onChange={(event) => handleSelectedAction(skuId, event.target.value)}
              >
                {actions.map((item) => (
                  <option key={item.value} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </Select>
            </Field>
          ) : null}
          <Field id={`${skuId}-reason`} label={`Motivo da ${getActionName(selectedType)}`}>
            <Select
              id={`${skuId}-reason`}
              value={selectedReason[skuId] || ""}
              required
              onChange={(event) => handleSelectedReason(skuId, event.target.value)}
            >
              {optionsReasons.map((item) => (
                <option key={item.value} value={item.value} disabled={item.disabled}>
                  {item.label}
                </option>
              ))}
            </Select>
          </Field>
          <Field id={`${skuId}-notes`} label="Comentário (opcional)">
            <TextArea
              id={`${skuId}-notes`}
              value={selectedExplication[skuId] || ""}
              onChange={(event) => handleSelectedExplication(skuId, event.target.value)}
            />
          </Field>
        </div>
      ) : null}
    </Card>
  );
};

export default ProductItem;
